import React from "react";
import styles from "./index.module.css";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import { IoLogoModelS } from "react-icons/io";
import { BsFuelPumpDieselFill } from "react-icons/bs";
import { IoColorPalette } from "react-icons/io5";
import { GiCarDoor, GiCarSeat, GiSteeringWheel } from "react-icons/gi";
import { CiBarcode } from "react-icons/ci";

const VehicleCardFull = ({
  id,
  name,
  imageUrl,
  price,
  wheelDrive,
  engineCC,
  mileage,
  fuelType,
  gearType,
  tag,
  year,
  model,
  modelCode,
  color,
  steering,
  doors,
  seats,
  stockNo,
  make
}) => {

  const currency = 'LKR'

  const convertedPrice =
    typeof price === "number" && typeof currency?.rate === "number"
      ? Math.round(price * currency.rate)
      : null;

  return (
    <Link to={`/vehicles/${id}`} className={styles.mainDiv}>
      <div className={styles.carCardTop}>

        {tag && (
          <span
            className={`${styles.tag} ${
              tag === "FEATURED"
                ? styles.featuredTag
                : tag === "POPULAR"
                ? styles.popularTag
                : ""
            }`}
          >
            {tag}
          </span>
        )}

        <img
          className={styles.carImage}
          src={imageUrl || ""}
          width={200}
          height={200}
          alt="car"
        />

        {/* Mobile Header */}
        <div className={styles.imageMobileHeader}>
          <img
            className={styles.mobileCarImage}
            src={imageUrl || ""}
            width={200}
            height={200}
            alt="car"
          />

          <div className={styles.mobilehheader}>
            <div className={styles.rightTopLeft}>
              <span className={styles.carName}>{name}</span>
              <span className={styles.carFeatures}>{make}</span>
            </div>

            <span className={styles.price}>
              <span className={styles.priceType}>{currency?.name} </span>
              {convertedPrice || ""}
            </span>

            <div className={styles.bottomDetail}>
              <Detail title="Year" value={year} />
              <Detail title="Engine" value={`${engineCC} cc`} />
              <Detail title="Mileage" value={`${mileage} km`} />
              <Detail title="Wheel Drive" value={wheelDrive} />
            </div>
          </div>
        </div>

        {/* Desktop Section */}
        <div className={styles.rightSec}>

          <div className={styles.rightTop}>
            <div className={styles.rightTopLeft}>
              <span className={styles.carName}>{name}</span>
              <span className={styles.carFeatures}>{make}</span>
            </div>

            {price ? (
              <span className={styles.price}>
                <span className={styles.priceType}>{currency?.name} </span>
                {convertedPrice || "Ask"}
              </span>
            ) : (
              <span className={styles.price}>Ask</span>
            )}
          </div>

          <div className={styles.carCardBottom}>

            <hr className={styles.linkLine} />

            <div className={`${styles.bottomDetail} ${styles.webSec}`}>
              <Detail title="Year" value={year} />
              <Detail title="Engine" value={`${engineCC} cc`} />
              <Detail title="Mileage" value={`${mileage} km`} />
              <Detail title="Wheel Drive" value={wheelDrive} />
            </div>

            <div className={styles.carStats}>

              <Stat icon={<IoLogoModelS />} title="Model" value={model} />
              <Stat icon={<IoLogoModelS />} title="Model Code" value={modelCode} />
              <Stat icon={<BsFuelPumpDieselFill />} title="Fuel" value={fuelType} />
              <Stat icon={<IoColorPalette />} title="Color" value={color} />
              <Stat icon={<GiSteeringWheel />} title="Steering" value={steering} />
              <Stat icon={<GiCarDoor />} title="Doors" value={doors} />
              <Stat icon={<GiCarSeat />} title="Seats" value={seats} />
              <Stat icon={<CiBarcode />} title="Stock No" value={stockNo} />

            </div>

          </div>

        </div>

      </div>
    </Link>
  );
};

export default VehicleCardFull;


/* Helper Components */

const Detail = ({ title, value }) => (
  <div className={styles.detailSec}>
    <p className={styles.title}>{title}</p>
    <p className={styles.titleValue}>{value}</p>
  </div>
);

const Stat = ({ icon, title, value }) => (
  <div className={styles.statCard}>
    <span className={styles.icon}>{icon}</span>
    <div className={styles.statCardRight}>
      <p className={styles.statTitle}>{title}</p>
      <span className={styles.statValue}>{value}</span>
    </div>
  </div>
);